<template>
  <div class="pa-agreement">
    <div class="pa-agreement__head">
      <i class="material-icons" aria-hidden="true">gavel</i>
      <div>
        <div class="pa-agreement__title">Website Publishing Agreement</div>
        <div class="pa-agreement__sub">
          You chose "POP publishes for me", so we need your written permission to publish on your site.
          Version {{ version }}.
        </div>
      </div>
    </div>

    <ul class="pa-agreement__bullets">
      <li v-for="b in bullets" :key="b"><i class="material-icons" aria-hidden="true">check</i>{{ b }}</li>
    </ul>

    <button type="button" class="pa-link pa-agreement__toggle" @click="expanded = !expanded">
      {{ expanded ? 'Hide the full agreement' : 'Read the full Website Publishing Agreement' }}
    </button>

    <publishing-agreement-text v-if="expanded" :client-name="siteName" :website-url="siteUrl" />

    <label class="pa-agreement__accept" :class="{ 'pa-agreement__accept--disabled': disabled }">
      <input type="checkbox" :checked="value" :disabled="disabled" @change="$emit('input', $event.target.checked)" />
      <span>{{ ackText }} <span class="pa-req">*</span></span>
    </label>
  </div>
</template>

<script>
import PublishingAgreementText from '@/components/SitesSingleView/PopAuthority/PublishingAgreementText.vue'
import { POP_AUTHORITY_AGREEMENT_VERSION } from '@/utils/popAuthority'
import { AGREEMENT_ACK_TEXT, AGREEMENT_PURCHASE_BULLETS } from '@/utils/popAuthorityAgreement'

/**
 * Website Publishing Agreement block of the packages page (design pa-setup.jsx AgreementStep).
 * Shown only when the site has not signed the current agreement in the setup wizard (older
 * version, or the site switched to "POP publishes for me" after setup); the text is shared with
 * the wizard's publishing step.
 */
export default {
  name: 'PopAuthorityPublishingAgreement',
  components: { PublishingAgreementText },
  props: {
    value: { type: Boolean, default: false },
    siteName: { type: String, default: 'your site' },
    siteUrl: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data () {
    return {
      expanded: false,
      bullets: AGREEMENT_PURCHASE_BULLETS,
      ackText: AGREEMENT_ACK_TEXT,
      version: POP_AUTHORITY_AGREEMENT_VERSION,
    }
  },
}
</script>

<style lang="scss" scoped>
@import './setup/setup.scss';

.pa-agreement {
  border: 1px solid var(--v-gray15Color-base, #e4e4e4);
  border-radius: 12px;
  background: #fff;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: var(--v-mainColor-base);

  &__head {
    display: flex;
    gap: 12px;
    align-items: flex-start;

    .material-icons {
      font-size: 26px;
      color: var(--v-profileAnchorColor-base);
    }
  }

  &__title {
    font-weight: 800;
    font-size: 1rem;
  }

  &__sub {
    font-size: 0.82rem;
    color: $pa-muted;
  }

  &__bullets {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 0.85rem;

    li {
      display: flex;
      gap: 6px;
      align-items: flex-start;
    }

    .material-icons {
      font-size: 16px;
      color: var(--v-green7Color-base, #25a97a);
    }
  }

  &__toggle {
    align-self: flex-start;
    font-size: 0.85rem;
  }

  .pa-agreement-text {
    margin-top: 0;
  }

  &__accept {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    font-size: 0.85rem;
    cursor: pointer;

    input {
      margin-top: 3px;
      accent-color: var(--v-profileAnchorColor-base);
    }

    &--disabled {
      opacity: 0.6;
      cursor: default;
    }
  }
}
</style>
